<template>
  <section
    class="register layout-pt-lg layout-pb-lg tw-mt-32 lg:tw-mt-24"
    :style="`background-color: var(--c-${vars.backgroundColor}) !important`"
  >
    <div
      class="container"
      v-if="(componentModes.UPDATE === mode && applicantUpdateView) || componentModes.CREATE === mode"
    >
      <div
        class="register_intro tw-hidden tw-flex-col tw-items-start tw-justify-center tw-text-start lg:tw-flex"
        :class="{ 'tw-text-center': vars.textCenterBool }"
      >
        <h2 v-if="vars.titleText" class="n-title-primary tw-mb-10" :style="`color: var(--c-${vars.titleColor})`">
          {{ vars.titleText }}
        </h2>
        <div
          v-else-if="vars.titleHtml"
          class="tw-flex tw-flex-wrap tw-justify-center tw-gap-3 tw-text-start lg:tw-gap-4"
          v-html="vars.titleHtml"
        ></div>
        <h2 v-else class="n-title-primary tw-mb-10" :style="`color: var(--c-${vars.titleColor})`">
          How our Heads Up Property Alerts help you
        </h2>
        <p v-if="!vars.customDescriptionText">{{ introText }}</p>
        <p v-else>{{ vars.customDescriptionText }}</p>
      </div>
      <div class="tw-visible lg:tw-hidden">
        <div class="tw-mt-4 tw-grid tw-grid-cols-12 tw-gap-x-3">
          <div
            v-for="(tab, index) in tabs"
            :key="`tab-${index}`"
            class="nc-tab nc-tab tw-relative tw-col-span-4 tw-flex tw-h-[100px] tw-flex-col tw-items-center tw-justify-between tw-border tw-pb-3 tw-pt-4 tw-text-center"
            :class="activeTab === index ? 'nc-tab-active tw-bg-[var(--c-primary)]' : ''"
            @click="changeTab(index)"
          >
            <i class="tw-text-2xl tw-text-black" :class="`nc-icon-${tab.icon}`"></i>
            <p>{{ tab.title }}</p>
          </div>
        </div>
      </div>
      <div
        class="register-cols tw-mt-0 tw-grid tw-grid-cols-12 tw-gap-x-5 md:tw-mt-5 lg:tw-mt-10 lg:tw-max-w-none xl:tw-mt-16"
      >
        <div
          class="tw-col-span-12 lg:tw-col-span-4"
          :class="activeTab === 0 ? 'tw-flex tw-flex-col' : 'tw-hidden lg:tw-flex lg:tw-flex-col'"
        >
          <register-contact-area ref="contactArea" :component="component" :mode="mode" :title="tabs[0].title" />
        </div>
        <div
          class="tw-col-span-12 lg:tw-col-span-4"
          :class="activeTab === 1 ? '' : 'tw-hidden lg:tw-flex lg:tw-flex-col'"
        >
          <register-property-criteria-area
            ref="propertyCriteriaArea"
            :component="component"
            :search-type="searchType"
            :mode="mode"
            version="v2"
            :title="tabs[1].title"
          />
        </div>
        <div
          class="tw-col-span-12 lg:tw-col-span-4"
          :class="activeTab === 2 ? '' : 'tw-hidden lg:tw-flex lg:tw-flex-col'"
        >
          <register-questions-area
            ref="questionsArea"
            :mode="mode"
            :search-type="searchType"
            :component="component"
            :title="tabs[2].title"
          />
        </div>
      </div>
      <div>
        <button
          v-if="activeTab < 2"
          class="n-primary tw-mt-10 !tw-w-full !tw-px-6 lg:!tw-hidden"
          @click="(changeTab(activeTab + 1), scrollToTop())"
        >
          NEXT STEP
        </button>

        <div v-else class="register-btns tw-flex tw-items-center tw-justify-end tw-gap-10">
          <lazy-library-text type="bold" class="tw-cursor-pointer" text="CANCEL" @click="onCancelled()">
          </lazy-library-text>
          <nc-button class="tw-uppercase" :label="submitButtonLabel" :is-disabled="isLoading" @on-click="onSave()" />
        </div>

        <div
          class="register-btns !tw-hidden tw-items-center tw-justify-end tw-gap-10 tw-border-t-2 tw-pt-8 lg:!tw-flex"
          style="border-color: var(--c-border)"
        >
          <lazy-library-text type="bold" class="tw-cursor-pointer" text="CANCEL" @click="onCancelled()">
          </lazy-library-text>
          <nc-button class="tw-uppercase" :label="submitButtonLabel" :is-disabled="isLoading" @on-click="onSave()" />
        </div>
      </div>
    </div>

    <popup :config="successModalConfig" @close="onSuccessModalClosed()">
      <template #content>
        <success :text="successPopupText" />
      </template>
    </popup>
  </section>
</template>

<script lang="ts">
import Register from '~/components/common/register/Register.vue';
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'Theme9Register',

  mixins: [ComponentMixin],

  extends: Register,

  components: {
    Register,
  },
});
</script>

<style scoped>
.nc-tab-active i,
.nc-tab-active p {
  color: white !important;
}

::v-deep .register-contact-area .custom-col-span {
  grid-column: span 12 / span 12;
}

::v-deep .register-contact-area span {
  font-size: 16px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
}

::v-deep .custom-find-btn button {
  text-transform: uppercase !important;
}

::v-deep .register-property .live-search-container input:focus {
  box-shadow: none !important;
}

::v-deep .register-property .location-selectbox {
  background-color: var(--c-primary) !important;
  color: white !important;
}

::v-deep .register-property .live-search-container input::placeholder {
  color: white !important;
}

::v-deep .register-cols h3 {
  text-transform: uppercase !important;
}

::v-deep .register-property .live-search-container .location-selectbox {
  color: white !important;
}

::v-deep .register-property small {
  font-weight: 400 !important;
  font-size: 16px !important;
  margin-top: 36px !important;
  margin-bottom: 20px !important;
}

::v-deep .register-property .custom-col-span2 {
  grid-column: span 6 / span 6;
}

::v-deep .register-property span.nc-text,
::v-deep .register-question-area span.nc-text {
  font-weight: 600 !important;
  font-size: 16px !important;
  text-transform: uppercase !important;
}

::v-deep .register-property .register-btns button .button-label {
  text-transform: uppercase !important;
}

@media screen and (min-width: 1280px) {
  ::v-deep .register-property .custom-col-span2 {
    grid-column: span 4 / span 4;
  }

  ::v-deep .register-contact-area .custom-col-span {
    grid-column: span 6 / span 6;
  }

  ::v-deep .register-property .advanced-box {
    grid-column: span 4 / span 4;
  }
}
</style>
